var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuaranteeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#D8ECED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2477 33.2472L50.9232 35.5686C51.3181 35.891 52.8335 36.3585 53.575 35.4235C54.4455 34.4804 54.2198 33.4649 53.4944 32.8765M53.4944 32.8765L45.7888 28C42.8146 30.007 40.2676 29.467 38.6314 28.6287C37.5997 28.1048 37.5674 26.6459 38.5588 26.0495L45.0554 22.1725C48.7147 20.0849 52.5513 23.1075 52.5513 23.1075L56.3558 21.4713L60.7647 28.9914L53.4944 32.8765Z",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5887 23.6476L40.9767 22.3983C39.7838 21.4713 38.3571 20.7862 36.4952 21.4875L31.1352 23.4864L27.629 21.5681L23.0186 28.4192L28.3383 32.006",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3363 31.1317L27.6368 32.6044C26.9842 33.17 26.9135 34.1575 27.4791 34.8102L27.648 35.0051C28.2135 35.6577 29.2011 35.7283 29.8537 35.1628L31.5532 33.6901C32.2059 33.1246 32.2765 32.137 31.711 31.4844L31.5421 31.2895C30.9765 30.6368 29.989 30.5662 29.3363 31.1317Z",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8526 35.1767L32.2222 33.1234C32.874 32.5586 33.8631 32.6293 34.4279 33.2811L34.5968 33.476C35.1616 34.1278 35.0909 35.117 34.4391 35.6818L32.0696 37.7351C31.4178 38.2999 30.4286 38.2291 29.8638 37.5773L29.6949 37.3824C29.1301 36.7306 29.2009 35.7415 29.8526 35.1767Z",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6857 35.4618L32.079 37.7214C31.4265 38.287 31.356 39.2746 31.9217 39.9272L32.0906 40.1221C32.6563 40.7746 33.6438 40.8451 34.2964 40.2794L36.9031 38.0198C37.5557 37.4541 37.6261 36.4666 37.0605 35.814L36.8915 35.6191C36.3259 34.9666 35.3383 34.8961 34.6857 35.4618Z",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0691 37.8802L35.8204 38.9623C35.1678 39.5279 35.0971 40.5154 35.6627 41.1681L35.8316 41.363C36.3971 42.0156 37.3847 42.0863 38.0373 41.5207L39.2861 40.4386C39.9387 39.8731 40.0093 38.8855 39.4438 38.2329L39.2749 38.038C38.7093 37.3853 37.7218 37.3147 37.0691 37.8802Z",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5547 35.5684L48.6735 38.4137C49.0684 38.7361 49.5681 38.8489 50.0276 38.7683C50.4145 38.7038 50.7772 38.4943 51.0432 38.1638C51.6315 37.4384 51.6396 36.1568 50.9142 35.5684L47.2387 33.2471",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4521 37.8101L45.7246 40.349C46.0792 40.615 46.5145 40.7117 46.9256 40.6392C47.2641 40.5828 47.5865 40.4055 47.8283 40.1233C48.3522 39.5108 48.4006 38.197 47.7719 37.7053L44.5478 35.5693",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4513 37.8096L43.7893 38.8493C45.2079 39.9455 44.2084 41.2996 44.2084 41.2996C44.2084 41.2996 43.2331 42.7666 41.2503 41.5011L39.4287 40.2921",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6292 21.5683L28.4191 20.456C28.7576 19.9804 28.6206 19.3115 28.1209 19.0052L25.9769 17.6994C25.5094 17.4173 24.9048 17.5543 24.6066 18.0057L18.5937 27.1137C18.2794 27.5893 18.4164 28.226 18.9 28.5243L20.9634 29.83C21.439 30.1363 22.0757 29.9832 22.3659 29.4995L23.0268 28.4114",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3628 21.4716L55.5729 20.3593C55.2344 19.8838 55.3714 19.2148 55.8711 18.9085L58.0151 17.6027C58.4826 17.3206 59.0871 17.4577 59.3854 17.909L65.4063 27.8472C65.7207 28.3228 65.5837 28.9596 65.1001 29.2578L63.0366 30.5635C62.5611 30.8698 61.9243 30.7167 61.6342 30.2331L60.9732 29.1449",
    stroke: "#0D4248",
    strokeWidth: 1.29957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteeIcon);
export default __webpack_public_path__ + "static/media/guarantee-icon.13307a97c0f3006d96c8dc292e7391fc.svg";
export { ForwardRef as ReactComponent };